const ERROR_MESSAGES = {
  'CVV must be 4 digits for American Express and 3 digits for other card types.': 'invalid-cvv',
  'Processor Network Unavailable - Try Again': 'network-error',
  Declined: 'transaction-declined',
  'Do Not Honor': 'transaction-declined',
  'Issuer or Cardholder has put a restriction on the card': 'transaction-declined',
  'Processor Declined': 'transaction-declined',
  'Payer Cannot Pay For This Transaction With PayPal': 'paypal-payer-error',
  'Card Issuer Declined CVV': 'cvv-wrong-details',
  'No Account': 'cvv-wrong-details',
  'Call Issuer. Pick Up Card.': 'lost-or-stolen-card',
  'Declined - Call Issuer': 'card-transaction-declined',
  'Expired Card': 'expired-card',
  "Funding Instrument In The PayPal Account Was Declined By The Processor Or Bank, Or It Can't Be Used For This Payment":
    'paypal-associated-payment-method-declined',
  'Insufficient Funds': 'insufficient-funds',
  'Invalid Transaction': 'invalid-transaction',
  'Transaction Not Allowed': 'transaction-not-allowed',
  'Voice Authorization Required': 'voice-authorization-required',
  'Payment method token is invalid.': 'invalid-payment-method-token-or-nonce',
  'Payment method nonce is invalid.': 'invalid-payment-method-token-or-nonce',
  'Billing cycle not supported.': 'unsupported-billing-cycle',
  'Cardholder Authentication Required': 'authentication-required',
  '3D Secure enriched payment method nonce did not authenticate successfully.': '3ds-failed',
  unknown: 'unknown',
};

export type PaymentDetailsErrorMessage = keyof typeof ERROR_MESSAGES;

/**
 * return translation keys for error code.
 *
 * Error message descriptions can be obtained from:
 * https://articles.braintreepayments.com/control-panel/transactions/declines
 *
 */
export function getErrorMessageTranslationKey(
  error: PaymentDetailsErrorMessage,
  i18nBase = '',
): string {
  // add trailing dot only if it doesn't exist
  const baseTrailingDot = i18nBase.endsWith('.') ? '' : '.';
  const base = i18nBase ? `${i18nBase}${baseTrailingDot}` : '';
  const key = ERROR_MESSAGES[error] ?? 'unknown';

  return `${base}${key}`;
}
